import styled from 'styled-components';

const Wrapper = styled.div`
  max-width: 40em;
  margin: auto;
`;

export default Wrapper;



// WEBPACK FOOTER //
// ./client/components/HomePage/About/SponsorLogos/Wrapper.js